import axios from "axios";

export default {
    update(id, data) {
        return axios({
            method: "put",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/invoice/" + id,
            data: data,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    rectify(id) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/invoice/" + id + "/rectify",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    cancel(id) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/invoice/" + id + "/cancel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    paidInvoiceCita(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/invoice/cita/" + id + "/paid",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/invoice/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    generatePdfInvoiceCita(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoice/cita/" +
                id +
                "/report",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    generatePdfInvoiceOldEvent(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoiceOld/" +
                id +
                "/report/event",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    generatePdfInvoiceEvent(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoice/" +
                id +
                "/report/event",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    sendPdfInvoiceEvent(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoice/" +
                id +
                "/send/event",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllExcel(data) {
        return axios({
            method: "post",
            responseType: "blob",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/invoices/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll(currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoices?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllOld(currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoicesOld?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllCita(currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoices/cita?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payStripeInvoiceCita(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoice/cita/" +
                id +
                "/pay/stripe",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payPaypalInvoiceCita(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoice/cita/" +
                id +
                "/pay/paypal",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    paySuccess(id, option, tokenback, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoice/cita/" +
                id +
                "/pay/success/" +
                option +
                "/" +
                tokenback,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCancel(id, mode, token, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/invoice/cita/" +
                id +
                "/pay/cancel/" +
                mode +
                "/" +
                token,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
